<div class="flex flex-col items-center justify-center py-12 px-4">
  <div class="text-gray-400 mb-3">
    <svg
      class="w-12 h-12 mx-auto"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  </div>
  <div class="text-gray-500 font-medium">Aucune donnée disponible.</div>
</div>
